import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: () => void;
  variant?: 'primary' | 'premium' | 'outline';
}
export function CTAButton({
  children,
  href,
  className = '',
  onClick,
  variant = 'primary'
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (onClick) {
      onClick();
    } else if (!href || href.startsWith('#')) {
      e.preventDefault();
      const targetId = href ? href.substring(1) : 'pricing';
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  const variants: Record<string, string> = {
    primary: 'bg-brand-terracotta text-white hover:bg-brand-terracotta-dark',
    premium: 'bg-brand-terracotta text-white hover:bg-brand-terracotta-dark ring-2 ring-brand-forest/20',
    outline: 'bg-brand-forest text-white hover:bg-brand-forest-dark'
  };
  const baseClasses = `
    relative inline-flex items-center justify-center w-full
    px-5 py-4 sm:px-6 sm:py-5
    font-bold text-sm sm:text-base uppercase tracking-wide
    rounded-xl shadow-lg
    hover:scale-[1.02] hover:shadow-xl
    transition-all duration-300 group overflow-hidden
    ${variants[variant]}
    ${className}
  `;
  const content = <span className="relative z-10 flex items-center text-center justify-center gap-2 leading-tight" data-id="element-40">
      <span data-id="element-41">{children}</span>
    </span>;
  if (href && !href.startsWith('#')) {
    return <a href={href} className={baseClasses} onClick={handleClick} data-id="element-42">
        {content}
      </a>;
  }
  return <button className={baseClasses} onClick={handleClick} data-id="element-43">
      {content}
    </button>;
}